module.exports = "//static.hsappstatic.net/LoginUI/static-1.8526/img/connect.com-full-logo-color.svg"